<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>资金费用管理</el-breadcrumb-item>
      <el-breadcrumb-item>资金费用记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions fund-rate-toolbar">
        <el-select
          v-model="query.symbol"
          placeholder="请选择合约"
          filterable
          clearable
          size="mini"
          class="toolbar-item"
        >
          <el-option
            v-for="item in symbolList"
            :key="item.id"
            :label="item.symbol.toUpperCase()"
            :value="item.symbol"
          />
        </el-select>
        <el-select
          v-model="query.collection"
          placeholder="是否收取"
          size="mini"
          class="toolbar-item"
        >
          <el-option label="已收取" :value="true" />
          <el-option label="未收取" :value="false" />
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          align="right"
          size="mini"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="timestamp"
          :picker-options="pickerOptions"
          class="toolbar-item toolbar-range"
          @change="onDateChange"
        />
        <el-button type="primary" size="mini" @click="search">查询</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" height="calc(100vh - 380px)" size="mini" border>
        <el-table-column type="index" width="50" label="序号" />
        <el-table-column prop="id" label="资金费用记录ID" min-width="160" show-overflow-tooltip />
        <el-table-column prop="symbol" label="合约名">
          <template slot-scope="scope">
            <span class="sym-upper">{{ scope.row.symbol }}</span>
          </template>
        </el-table-column>
        <el-table-column label="资金费率">
          <template slot-scope="scope">
            <span>{{ formatFundRatePercent(scope.row.fundingRate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="takeAmount" label="总收取" />
        <el-table-column prop="payAmount" label="总发放" />
        <el-table-column label="是否收取">
          <template slot-scope="scope">
            <span v-if="scope.row.collection" class="green">已收取</span>
            <span v-else class="red">未收取</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.collection"
              type="text"
              size="mini"
              @click="goDetail(scope.row)"
            >
              资金明细
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="paginations.size"
        :page="paginations.page"
        :total="total"
        @pageChanged="handlePageChanged"
      />
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from 'components/pagination'
import BigNumber from 'bignumber.js'
import api from '../FundRate/api'

export default {
  name: 'SimulationFundRateRecord',
  components: { Pagination },
  data() {
    return {
      symbolList: [],
      tableData: [],
      total: 0,
      dateRange: [],
      query: {
        symbol: '',
        collection: true,
      },
      paginations: { page: 1, size: 10 },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  mounted() {
    this.initDateRange()
    this.loadSymbols()
  },
  methods: {
    initDateRange() {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.dateRange = [start.getTime(), moment(end).endOf('day').valueOf()]
    },
    onDateChange(val) {
      if (!val || val.length !== 2) {
        this.dateRange = []
      }
    },
    timeParams() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        return { startTime: null, endTime: null }
      }
      return {
        startTime: this.dateRange[0],
        endTime: moment(this.dateRange[1]).endOf('day').valueOf(),
      }
    },
    formatFundRatePercent(rate) {
      if (rate == null || rate === '') return '-'
      return `${new BigNumber(rate).times(100).toNumber().toFixed(6)}%`
    },
    loadSymbols() {
      return api.getSymbolList().then((res) => {
        if (res.code === 0 && res.data) {
          this.symbolList = res.data
        }
      })
    },
    buildRequestParams() {
      const { startTime, endTime } = this.timeParams()
      const params = {
        page: this.paginations.page,
        size: this.paginations.size,
        collection: this.query.collection,
        startTime,
        endTime,
      }
      if (this.query.symbol) {
        params.symbol = this.query.symbol
      }
      return params
    },
    fetchList() {
      const { startTime, endTime } = this.timeParams()
      if (startTime == null || endTime == null) {
        this.$message.warning('请选择时间范围')
        return
      }
      api.getFundRecordList(this.buildRequestParams()).then((res) => {
        if (res.code === 0 && res.data) {
          this.tableData = res.data.items || []
          this.total = Number(res.data.total || 0)
        }
      })
    },
    search() {
      if (!this.query.symbol) {
        this.$message.warning('请选择合约')
        return
      }
      this.paginations.page = 1
      this.fetchList()
    },
    reset() {
      this.query = { symbol: '', collection: true }
      this.paginations = { page: 1, size: 10 }
      this.initDateRange()
      this.tableData = []
      this.total = 0
    },
    handlePageChanged(p) {
      this.paginations = { page: p.page, size: p.size }
      this.fetchList()
    },
    goDetail(row) {
      this.$router.push({
        path: '/home/simulation/fundRateBill',
        query: {
          symbol: row.symbol,
          fundRateRecordId: row.id != null ? String(row.id) : undefined,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.fund-rate-toolbar {
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
}
.toolbar-item {
  margin-right: 8px;
}
.toolbar-range {
  width: 260px;
}
.green {
  color: #67c23a;
}
.red {
  color: #f56c6c;
}
.sym-upper {
  text-transform: uppercase;
}
</style>
